import { Components, Theme } from '@mui/material';

const MuiStepIcon: Components<Theme>['MuiStepIcon'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.Mui-active': {
        color: theme.palette.grey[900],
      },
    }),
  },
};

export default MuiStepIcon;
